import React, { useState } from "react";
import PropTypes from "prop-types";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { FileUpload } from "primereact/fileupload";

// Providers that fetch data from their own API — no file upload needed
const FILE_OPTIONAL_PROVIDERS = ["ESSO", "Suncore"];

const PIPELINE_OPTIONS = [
  { label: "Pipeline Transactions File", value: "txn-file" },
  { label: "Pipeline Invoice", value: "invoice" },
];

const UploadModal = ({ visible, onHide, onUpload, header = "Import Transaction", fileOptional = false }) => {
  const [selectedFileType, setSelectedFileType] = useState(null);
  const [pipelineOption, setPipelineOption] = useState(null);
  const [file, setFile] = useState(null);
  const [beginDate, setBeginDate] = useState("");
  const [endDate, setEndDate] = useState("");



  const fileTypes = [
    { label: "ESSO", value: "ESSO" },
    { label: "Suncore", value: "Suncore" },
    { label: "Comdata", value: "Comdata" },
    { label: "Pipeline", value: "Pipeline" },
    { label: "TAPetro", value: "TAPetro" },
  ];

  const isEssoProvider = selectedFileType === "ESSO";
  // ESSO fetches from its own API — no file upload needed in any modal
  const needsFile = isEssoProvider ? false : true;

  const handleFileSelect = (event) => {
    if (event.files && event.files.length > 0) {
      setFile(event.files[0]);
    }
  };

  const isPipeline = selectedFileType === "Pipeline";
  const medium = isPipeline && pipelineOption === "txn-file" ? "txn-file" : isPipeline && pipelineOption === "invoice" ? "invoice" : undefined;

  const resetState = () => {
    setFile(null);
    setSelectedFileType(null);
    setPipelineOption(null);
    setBeginDate("");
    setEndDate("");
  };

  const handleUpload = () => {
    if (selectedFileType && (file || !needsFile)) {
      onUpload(file, selectedFileType, resetState, beginDate || undefined, endDate || undefined, medium);
      onHide();
    }
  };

  const handleClose = () => {
    resetState();
    onHide();
  };

  return (
    <Dialog
      header={header}
      visible={visible}
      style={{ width: "35vw" }}
      modal
      onHide={handleClose}
      closable={true}
      className="upload-modal"
      ariaCloseButtonLabel="Close"
    >
      <div className="p-fluid">
        <p>Warning: This process may take several minutes.</p>
        <Dropdown
          value={selectedFileType}
          options={fileTypes}
          onChange={(e) => { setSelectedFileType(e.value); setPipelineOption(null); }}
          placeholder="Select File Type"
          className="mb-3"
        />
        {isPipeline && (
          <Dropdown
            value={pipelineOption}
            options={PIPELINE_OPTIONS}
            onChange={(e) => setPipelineOption(e.value)}
            placeholder="Select Pipeline Option"
            className="mb-3"
          />
        )}
        {isEssoProvider && (
          <div className="mb-3">
            <div className="mb-2">
              <label className="mb-1 d-block">Begin Date</label>
              <input
                type="date"
                className="p-inputtext p-component w-100"
                value={beginDate}
                onChange={(e) => setBeginDate(e.target.value)}
              />
            </div>
            <div>
              <label className="mb-1 d-block">End Date</label>
              <input
                type="date"
                className="p-inputtext p-component w-100"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
              />
            </div>
          </div>
        )}
        {needsFile && (
          <>
            <FileUpload
              mode="basic"
              chooseLabel="Select File"
              customUpload
              auto
              onSelect={handleFileSelect}
              accept=".xls,.xlsx"
            />
            {file && <p className="mt-2">Selected file: {file.name}</p>}
          </>
        )}
      </div>

      <div className="d-flex justify-content-end mt-4">
        <Button
          label="Close"
          onClick={handleClose}
          className="p-btn-danger p-button-outlined mr-2"
        />
        <Button
          label={needsFile ? "Upload" : fileOptional ? "Validate" : "Import"}
          onClick={handleUpload}
          className="p-button-raised"
          disabled={!selectedFileType || (isPipeline && !pipelineOption) || (needsFile && !file) || (isEssoProvider && (!beginDate || !endDate))}
        />
      </div>
    </Dialog>
  );
};

UploadModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  onUpload: PropTypes.func.isRequired,
};

export default UploadModal;
